var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._l((_vm.menus),function(menu,index){return [(!menu.disable)?_c('router-link',{key:index,staticClass:"link",attrs:{"to":menu.url},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{attrs:{"active":isActive,"href":href},on:{"click":navigate}},[(menu.img)?_c('img',{attrs:{"src":menu.img}}):_vm._e(),_c('span',[_vm._v(_vm._s(menu.label))])])]}}],null,true)}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }